export function getTranslateXY(element: HTMLElement) {
    const style = window.getComputedStyle(element)
    const matrix = new DOMMatrixReadOnly(style.transform)
    return {
        x: matrix.m41,
        y: matrix.m42
    }
}

export function mergeRefs(...inputRefs: any[]) {
    return (ref: any) => {
      inputRefs.forEach((inputRef) => {
        if (!inputRef) {
          return;
        }
  
        if (typeof inputRef === 'function') {
          inputRef(ref);
        } else {
          // eslint-disable-next-line no-param-reassign
          inputRef.current = ref;
        }
      });
    };
  }

export async function checkMagicBytes (file: File) {
    const magicBlob = file.slice(0, 12);
    const magicBuffer = await magicBlob.arrayBuffer();
    const magicBytes = new Uint8Array(magicBuffer);
    const magicString = magicBytes.reduce<string>((ms, mByte) => ms + mByte.toString(16), '');
    switch (magicString.slice(0, 8)) {
      case "89504e47": // PNG
          return true;
      case "ffd8ffe0":
      case "ffd8ffe1":
      case "ffd8ffe2":
      case "ffd8ffe3":
      case "ffd8ffe8":
          return true; // JPEG
      case "47494638":
         return true; // GIF
      default:
          return /^52494646[0-9a-z]+57454250$/.test(magicString); // WEBP
    }
  }

export function parseJwt (token: string | null) {
    let base64Url = token!.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}
